import { render, staticRenderFns } from "./DateTimeStatusColors.vue?vue&type=template&id=2a2f1720&scoped=true"
import script from "./DateTimeStatusColors.vue?vue&type=script&lang=js"
export * from "./DateTimeStatusColors.vue?vue&type=script&lang=js"
import style0 from "./DateTimeStatusColors.vue?vue&type=style&index=0&id=2a2f1720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f1720",
  null
  
)

export default component.exports